import axios from 'axios'
import * as Sentry from '@sentry/browser'
import qs from 'qs'

import { identifyCurrentUser } from 'utils/fullstory'
import { initializePendo } from 'utils/pendo'
import { initializeProfitwell } from 'utils/profitwell'
import { baseURL } from 'utils/io'
import { restartDeveloperSocket } from 'utils/developers'

const SET_CURRENT_USER = Symbol('SET_CURRENT_USER')
const SET_CURRENT_USER_TOKEN = Symbol('SET_CURRENT_USER_TOKEN')
const SET_AUTH_VISIBLE = Symbol('SET_AUTH_VISIBLE')
const REQUEST_USERS = 'REQUEST_USERS'

const INITIAL_STATE = {
  users: [],
  currentUser: null,
  currentUserToken: null,
  authVisible: false,
}

// Reducer

export default (state = INITIAL_STATE, action) => {
  if (action.type === SET_CURRENT_USER) {
    const { userObject } = action
    window.adaloDeveloper = userObject.developer

    // Setup analytics tools
    Sentry.configureScope(scope => {
      scope.setUser({ email: userObject.email })
    })

    identifyCurrentUser(userObject)
    initializePendo(userObject)
    initializeProfitwell(userObject)

    return {
      ...state,
      currentUser: userObject,
      authVisible: false,
    }
  }

  if (action.type === SET_CURRENT_USER_TOKEN) {
    const { token } = action

    axios.defaults.headers['x-proton-auth'] = token

    restartDeveloperSocket(token)

    return {
      ...state,
      currentUserToken: token,
      authVisible: false,
    }
  }

  if (action.type === SET_AUTH_VISIBLE) {
    return {
      ...state,
      authVisible: true,
    }
  }

  if (action.type === `${REQUEST_USERS}_FULFILLED`) {
    return {
      ...state,
      users: action.payload.data,
    }
  }

  return state
}

// Actions

export const setCurrentUser = userObject => ({
  type: SET_CURRENT_USER,
  userObject,
})

export const setCurrentUserToken = token => ({
  type: SET_CURRENT_USER_TOKEN,
  token,
})

export const setAuthVisible = () => ({
  type: SET_AUTH_VISIBLE,
})

export const requestUsers = opts => ({
  type: REQUEST_USERS,
  payload: axios.get(`${baseURL}/users?${qs.stringify(opts)}`),
})

// Selectors

export const getCurrentUser = state => {
  return state.users.currentUser
}

export const getCurrentUserToken = state => {
  return state.users.currentUserToken
}

export const getAuthVisible = state => {
  return state.users.authVisible
}

export const getUsers = state => {
  return state.users.users
}
